<template>
  <v-container
    class="ma-0 pa-0 sweetspot-page-container"
    fluid
  >
    <div v-if="showAlert">
      <v-alert
        class="v-alert alert_overlay"
        v-model="showAlert"
        border="left"
        close-text="Close Alert"
        dismissible
        :type="alertType"
      >
        {{ alertMsg }}
      </v-alert>
    </div>
    <v-row class="ma-0 pa-0 full-height-row">
      <v-col cols="12" class="ma-0 pa-0 full-height-column">
        <v-row class="ma-0 px-6 pt-4 pb-2 title-row">
          <v-col cols="12" class="ma-0 pa-0">
            <v-row width="100%" class="ma-0 pa-0 title-header-row" align="center">
              <v-col cols="auto" class="ma-0 pa-0">
                <v-img :src="main_logo" max-height="48px" max-width="80px" contain></v-img>
              </v-col>
              <v-col cols="auto" class="ma-0 pa-0">
                <span class="page-title">SweetSpot</span>
              </v-col>
              <v-spacer></v-spacer>
              <v-col
                v-if="sweetspot_tab === 'overview'"
                cols="auto"
                class="ma-0 pa-0 sweetspot-main-stats"
              >
                <v-row class="ma-0 pa-0" align="center">
                  <v-col cols="auto" class="ma-0 pa-0 sweetspot-main-stat">
                    <PerformanceMainStatistic
                      statistic_title_name="Omni. Spend"
                      :value="market_omni_channels.spend"
                      value_format=""
                    ></PerformanceMainStatistic>
                  </v-col>
                  <v-col cols="auto" class="ma-0 pa-0 sweetspot-main-stat">
                    <PerformanceMainStatistic
                      statistic_title_name="Omni. Reach %"
                      :value="market_omni_channels.reach_pct"
                      value_format="pct"
                    ></PerformanceMainStatistic>
                  </v-col>
                  <v-col cols="auto" class="ma-0 pa-0 sweetspot-main-stat">
                    <PerformanceMainStatistic
                      statistic_title_name="Omni. Avg. Freq."
                      :value="market_omni_channels.avg_freq"
                      value_format="abs"
                    ></PerformanceMainStatistic>
                  </v-col>
                  <v-col cols="auto" class="ma-0 pa-0 sweetspot-main-stat">
                    <PerformanceMainStatistic
                      statistic_title_name="Omni. Imps."
                      :value="market_omni_channels.impressions"
                      value_format="abs"
                    ></PerformanceMainStatistic>
                  </v-col>
                  <v-col cols="auto" class="ma-0 pa-0 sweetspot-main-stat">
                    <PerformanceMainStatistic
                      statistic_title_name="Omni. GRPs"
                      :value="market_omni_channels.grps"
                      value_format="abs"
                    ></PerformanceMainStatistic>
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
            <v-row width="100%" class="ma-0 pa-0">
              <v-col cols="auto" class="ma-0 pa-0 d-flex justify-end pb-2">
                <v-tabs v-model="sweetspot_tab" align-tabs="start" light>
                  <v-tab class="tool-navigation-bar" href="#saved">My Plans</v-tab>
                  <v-tab :disabled="sweetspot_tab == 'saved'" class="tool-navigation-bar" href="#overview">Plan Overview</v-tab>
                </v-tabs>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
        <v-tabs-items
          class="ma-0 pa-0 tab-content"
          v-model="sweetspot_tab"
        >
          <v-tab-item
              class="tab-item"
              value="saved"
            >
              <div width="100%" class="ma-0 pa-0 tab-panel-content">
                <SweetSpotSaved
                  :report_id="sweetspot_report_id"
                  :report_loading="sweetspot_report_loading"
                  v-on:open_report="open_report"
                  v-on:triggerAlert="triggerAlert"
                  ></SweetSpotSaved>
              </div>
          </v-tab-item>
          <v-tab-item
              class="tab-item"
              value="overview"
            >
              <div width="100%" class="ma-0 pa-0 tab-panel-content">
                <SweetSpotOverview
                  ref="sweetSpotOverview"
                  :report_id="sweetspot_report_id"
                  :report_updated_time="report_updated_time"
                  v-on:triggerAlert="triggerAlert"
                  v-on:report_saved="handleReportSaved"
                  v-on:report_loading_changed="handleReportLoadingChanged"
                  v-on:unsaved_cell_edits_changed="handleUnsavedCellEditsChanged"
                  v-on:omni_channel_enabled_changed="handleOmniChannelEnabledChanged"
                  v-on:market_omni_channels_changed="handleMarketOmniChannelsChanged"
                ></SweetSpotOverview>
              </div>
          </v-tab-item>
        </v-tabs-items>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import logo from "@/assets/SweetSpotLogo.png";
import SweetSpotSaved from "./SweetSpotSections/SweetSpotSaved.vue";
import SweetSpotOverview from "./SweetSpotSections/SweetSpotReport.vue";
import PerformanceMainStatistic from "@/components/Performance/PerformanceStats/PerformanceReportSections/PerformanceMainStatistic.vue";

export default {
  name: "SweetSpotBasePage",
  components: {
    SweetSpotSaved,
    SweetSpotOverview,
    PerformanceMainStatistic,
  },
  beforeDestroy() {
    clearTimeout(this.alertTimeout);
  },
  data: () => ({
    alertMsg: null,
    alertType: null,
    showAlert: false,
    alertTimeout: null,
    main_logo: logo,
    sweetspot_tab: "saved",
    sweetspot_report_id: 0,
    report_updated_time: null,
    can_save_report: false,
    sweetspot_report_loading: false,
    omni_channel_enabled: false,
    market_omni_channels: {
      reach_pct: null,
      avg_freq: null,
      impressions: null,
      grps: null,
      spend: null
    },
  }),
  methods: {
    triggerAlert: function (type, message) {
      this.alertType = type ? type : "info";
      this.alertMsg = message;
      this.showAlert = true;
      clearTimeout(this.alertTimeout);
      this.alertTimeout = setTimeout(() => {
        this.showAlert = false;
        this.alertTimeout = null;
      }, 5000);
    },
    handleOmniChannelEnabledChanged: function (value) {
      this.omni_channel_enabled = value;
    },
    handleReportSaved: function (payload) {
      if (typeof payload === "object" && payload !== null) {
        this.report_updated_time = payload.updated_time || new Date().toISOString();

        if (payload.clear_unsaved_cell_edits) {
          this.can_save_report = false;
        }
        return;
      }

      this.report_updated_time = payload || new Date().toISOString();
      this.can_save_report = false;
    },
    handleUnsavedCellEditsChanged: function (value) {
      this.can_save_report = value;
    },
    handleReportLoadingChanged: function (value) {
      this.sweetspot_report_loading = value;
    },
    handleMarketOmniChannelsChanged: function (value) {
      this.market_omni_channels = {
        reach_pct: value?.reach_pct ?? null,
        avg_freq: value?.avg_freq ?? null,
        impressions: value?.impressions ?? null,
        grps: value?.grps ?? null,
        spend: value?.spend ?? null
      };
    },
    open_report: function (payload) {
      const report_id = typeof payload === "object" && payload !== null
        ? payload.report_id
        : payload;

      this.sweetspot_tab = "overview";
      this.sweetspot_report_id = report_id;
      this.report_updated_time =
        typeof payload === "object" && payload !== null
          ? payload.updated_time || null
          : null;
      this.can_save_report = false;
      this.market_omni_channels = {
        reach_pct: null,
        avg_freq: null,
        impressions: null,
        grps: null,
        spend: null
      };
    },
  },
};
</script>

<style scoped>
.sweetspot-page-container {
  height: calc(100vh - 96px);
  max-height: calc(100vh - 96px);
  overflow-y: hidden;
  width: 100%;
}

.full-height-row,
.full-height-column,
.tab-panel-content {
  height: 100%;
}

.title-row {
  max-height: 20%;
  min-height: 10%;
}

.title-header-row {
  min-height: 60px;
}

.tab-content {
  height: calc(100vh - 230px);
  max-height: calc(100vh - 230px);
  width: 100%;
}

.tab-item {
  height: 100%;
  max-height: 100%;
  width: 100%;
}

.page-title {
  font-family: "Poppins" !important;
  font-weight: 800;
  font-size: 2em;
}
.plan-title {
  font-family: "Poppins" !important;
  font-weight: 600;
  font-size: 1.4em;
}
.tool-navigation-bar {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 0.9em !important;
}

.sweetspot-main-stats {
  min-width: 360px;
}

.sweetspot-main-stat {
  height: 56px;
  min-width: 170px;
}

.planning_section_action_text {
  font-family: "Poppins" !important;
  font-weight: 400 !important;
  font-size: 0.9em !important;
  color: black;
}

/deep/.v-window__container {
  height: 100% !important;
}
.optimization_calculator_action {
  font-family: 'Poppins' !important;
  font-weight: 400 ;
}
.v-alert {
  position: fixed;
  left: 50%;
  width: 100%;
  transform: translate(-50%, 0%);
  z-index: 2;
}
.alert_overlay {
  position: absolute;
  width: 100%;
  z-index: 99;
}
</style>
